"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModalConditions = void 0;
function getModalConditions(bindFromField, interaction) {
    var mleIncluded = bindFromField("optionalExtras.motorLegalExpenses");
    var ghcIncluded = bindFromField("optionalExtras.courtesyCar");
    var isEssentialsTier = interaction.coverTier === 'ALLIANZ_ESSENTIALS';
    var isSilverTier = interaction.coverTier === 'ALLIANZ_SILVER';
    var tierEligibility = bindFromField("tierEligibility");
    var tiersAvailable = function (tiers, matchAll) {
        var tiersEligible = tiers.map(function (requiredTier) { return !!(tierEligibility === null || tierEligibility === void 0 ? void 0 : tierEligibility[requiredTier]); });
        return matchAll ? tiersEligible.every(Boolean) : tiersEligible.some(Boolean);
    };
    return [
        {
            isModalShown: interaction.uistate.modalShownEssentialsGHCAndMLESelected,
            stateKey: "showModalEssentialsGHCAndMLESelected",
            uiStateKey: "uistate.modalShownEssentialsGHCAndMLESelected",
            conditionCheck: function () { return mleIncluded && ghcIncluded && isEssentialsTier && tiersAvailable(["allianz"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownEssentialsGHCSelected,
            stateKey: "showModalEssentialsGHCSelected",
            uiStateKey: "uistate.modalShownEssentialsGHCSelected",
            conditionCheck: function () { return !mleIncluded && ghcIncluded && isEssentialsTier && tiersAvailable(["allianz", "silver"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownEssentialsMLESelected,
            stateKey: "showModalEssentialsMLESelected",
            uiStateKey: "uistate.modalShownEssentialsMLESelected",
            conditionCheck: function () { return mleIncluded && !ghcIncluded && isEssentialsTier && tiersAvailable(["allianz", "silver"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownSilverMLESelected,
            stateKey: "showModalSilverMLESelected",
            uiStateKey: "uistate.modalShownSilverMLESelected",
            conditionCheck: function () { return mleIncluded && isSilverTier && tiersAvailable(["allianz"], false); },
        },
        {
            isModalShown: interaction.uistate.modalShownSilverGHCAndMLESelected,
            stateKey: "showModalSilverGHCAndMLESelected",
            uiStateKey: "uistate.modalShownSilverGHCAndMLESelected",
            conditionCheck: function () { return mleIncluded && ghcIncluded && isSilverTier && tiersAvailable(["allianz"], false); },
        }
    ];
}
exports.getModalConditions = getModalConditions;
//# sourceMappingURL=AnnualMotorTierUpgradeModalConditions.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/annual/motor/AnnualMotorTierUpgradeModalConditions.js
// module id = 1247
// module chunks = 0